import { useMemo } from "react";
import { resolveStorytellingNameParts } from "./storytellingPresentation";
import { STORYTELLING_TYPOGRAPHY_DEFAULT_COLORS } from "./storytellingFonts";

function StorytellingNameDisplaySection({
  restaurantName,
  display,
  updateDisplay,
  menuButtonColor,
  t,
}) {
  const previewParts = useMemo(
    () => resolveStorytellingNameParts(restaurantName, display),
    [restaurantName, display]
  );

  const accentFallback = display.accentColor || menuButtonColor || "#c1a37a";
  const defaultPrimaryColor = STORYTELLING_TYPOGRAPHY_DEFAULT_COLORS.name;

  const handleSplitIndexChange = (value) => {
    if (value === "" || value === null || value === undefined) {
      updateDisplay("nameSplitIndex", null);
      return;
    }
    const parsed = Number(value);
    if (!Number.isInteger(parsed) || parsed <= 0) {
      updateDisplay("nameSplitIndex", null);
      return;
    }
    updateDisplay("nameSplitIndex", parsed);
  };

  return (
    <div className="storytelling-stepper__control-section mb-4">
      <h5 className="storytelling-stepper__control-title">
        {t("storytellingNameDisplayLabel")}
      </h5>
      <p className="text-muted small mb-3">{t("storytellingNameDisplayHint")}</p>

      <div className="mb-3">
        <label className="form-label text-primary" htmlFor="storytelling-name-part-primary">
          {t("storytellingNamePartPrimaryLabel")}
        </label>
        <input
          id="storytelling-name-part-primary"
          type="text"
          className="form-control"
          value={display.namePartPrimary || ""}
          placeholder={previewParts.primary || t("storytellingNamePartPrimaryPlaceholder")}
          onChange={(e) => updateDisplay("namePartPrimary", e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label text-primary" htmlFor="storytelling-name-part-accent">
          {t("storytellingNamePartAccentLabel")}
        </label>
        <input
          id="storytelling-name-part-accent"
          type="text"
          className="form-control"
          value={display.namePartAccent || ""}
          placeholder={previewParts.accent || t("storytellingNamePartAccentPlaceholder")}
          onChange={(e) => updateDisplay("namePartAccent", e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label text-primary" htmlFor="storytelling-name-split-index">
          {t("storytellingNameSplitIndexLabel")}
        </label>
        <input
          id="storytelling-name-split-index"
          type="number"
          min="1"
          className="form-control"
          value={display.nameSplitIndex ?? ""}
          placeholder={t("storytellingNameSplitIndexPlaceholder")}
          onChange={(e) => handleSplitIndexChange(e.target.value)}
        />
        <small className="text-muted d-block mt-1">
          {t("storytellingNameSplitIndexHint", {
            name: restaurantName || t("storytellingNameSplitIndexFallbackName"),
            primary: previewParts.primary,
            accent: previewParts.accent,
          })}
        </small>
      </div>

      <div className="mb-3">
        <label className="form-label text-primary" htmlFor="storytelling-name-primary-color">
          {t("storytellingNamePrimaryColorLabel")}
        </label>
        <div className="storytelling-stepper__color-row">
          <input
            id="storytelling-name-primary-color"
            type="color"
            value={display.nameColor || defaultPrimaryColor}
            onChange={(e) => updateDisplay("nameColor", e.target.value)}
          />
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => updateDisplay("nameColor", defaultPrimaryColor)}
          >
            {t("storytellingResetColor")}
          </button>
        </div>
      </div>

      <div>
        <label className="form-label text-primary" htmlFor="storytelling-name-accent-color">
          {t("storytellingNameAccentColorLabel")}
        </label>
        <div className="storytelling-stepper__color-row">
          <input
            id="storytelling-name-accent-color"
            type="color"
            value={display.nameAccentColor || accentFallback}
            onChange={(e) => updateDisplay("nameAccentColor", e.target.value)}
          />
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => updateDisplay("nameAccentColor", "")}
          >
            {t("storytellingResetNameAccentColor")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default StorytellingNameDisplaySection;
